import React from "react";
import PropTypes from "prop-types";

import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";

import useStyles from "./CloseButton.styles";

const CloseButton = ({ onClick, text, children, label }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      {text || children}
      <IconButton className={classes.button} onClick={onClick} size="large">
        <CloseIcon data-cy={label ? `${label}-close-icon` : "close-icon"} />
      </IconButton>
    </div>
  );
};

CloseButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  text: PropTypes.node,
  children: PropTypes.node,
  label: PropTypes.string,
};

CloseButton.defaultProps = {
  text: "",
  children: "",
  label: "",
};

export default CloseButton;
